import React, { Component } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../services/CoreService";

import "./../../CSS/auth-styles.css";
import "../ViewReceipt/view-receipt-styles-only.css";


function getUrlInfo()
{
    var result =  window.location;
    var searchParams = getQueryMap(window.location.search);
    result.searchParams = searchParams;
    return result;
}

function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}


export default class GrowerReceiptPage extends Component {


  // TAKES A PROP CALLED RECEIPT
  constructor(props) 
  {
    super(props);

    this.coreService = new CoreService();
    this.state = 
    {
      receipt: null,
      isBusy: true,
      busyMessage: "loading",
      errorBag: {}
    };

  }


  async sleep(ms)
  {
    await new Promise(r => setTimeout(r, ms));
  }

  async componentDidMount()
  {
    this.setState({isBusy: true, busyMessage: "loading..."});
    await this.sleep(1000);
    try
    {
      
      var urlInfo = getUrlInfo();
      var token = urlInfo.hash.replace("#/r/", "");
      this.setState({receiptToken: token});
      // we need to look up our token
      var tokenResult = await this.coreService.fetchReceiptByToken(token);
      if (tokenResult.hasError)
      {
        var errorBag = this.state.errorBag;
        errorBag.receipt = "Unable to locate a receipt with token " + token;
        this.setState({errorBag: errorBag});
      }
      var receipt = tokenResult.dataResult;
      this.setState({receipt: receipt});
      
    }
    finally
    {
      this.setState({isBusy: false, busyMessage: ""});
    }
  }



  receiptHeader(receipt)
  {
      return (
      <table   data-type="text" border="0" cellPadding="0"
          cellSpacing="0" width="100%" style={{tableLayout: "fixed"}}
          >
          <tbody>
            <tr>
              <td style={{padding: "18px 0px 18px 0px", lineHeight: "6px", textAlign: "inherit"}}
                height="100%" valign="top" bgcolor="">
                <div>
                  <h1 style={{textAlign: "center"}}><span
                    style={{color: "white", fontSize: "30px", fontFamily: "helvetica, sans-serif"}}>Cal
                    Giant Cooler Receipt</span></h1>
                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      );
  
  }


  receiptTop(receipt)
  {
    return (
    <table border="0" cellPadding="0"
      cellSpacing="0" width="100%" style = {{tableLayout: "fixed"}}
      >
      <tbody>
        <tr>
          <td height="100%" valign="top">
            <table cellSpacing="1" cellPadding="8" style={{border: "none", width: "100%"}}>
              <tbody>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Receipt ID</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>#{ receipt.tagId }</td>
                </tr>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Receipt Date/Time</th>


                  {/* NEED DATE FORMATTING HERE */}
                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{ moment(receipt.receiveDateTime).format("MM/DD/YYYY HH:MM") }</td>
                </tr>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Receiver</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{ receipt.receiverId }</td>
                </tr>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Location</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{ receipt.warehouseName }</td>
                </tr>



                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Reference</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{receipt.reference }</td>
                </tr>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Description</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{ receipt.lot }</td>
                </tr>

                <tr>
                  <th style={{textAlign: "left", backgroundColor: "rgb(42,136,234)", color: "white", border: "none", width: "150px"}}>Total Qty Received</th>

                  <td style={{background: "white", color: "#4d4d4d", border: "none"}}>{ receipt.tagUnitQty }</td>
                </tr>

              </tbody>
            </table>
            <br />
          </td>
        </tr>
      </tbody>
    </table>
    );
  }

  receiptLines(receipt)
  {

        return (
        <table  border="0" cellPadding="0"
          cellSpacing="0" width="100%" style={{tableLayout: "fixed"}}
          >
          <tbody>
            <tr>
              <td height="100%" valign="top">
                {receipt.lines.map(line =>
                {
                  return this.receiptLine(line);
                }
                )}
                <br />
              </td>
            </tr>
          </tbody>
        </table>
        );
  }

  receiptLine(line)
  {
    return (
    <table cellSpacing="1" cellPadding="8" style={{border: "none", width: "100%"}}>
    <tbody>
      <tr>
        <th style={{fontWeight: "bold", color: "white"}} >Line {line.lineNbr}</th>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Grower Name</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.growerName} ({line.growerId})</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Block Name</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.blockName}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Pool Name</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.poolName}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Variety</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.varietyName}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Product</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.itemName}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Grade</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.grade}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>UOM</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.uomName}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Line Qty</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.tagLineQty}</td>
      </tr>

      <tr>
        <th style={{textAlign: "left", backgroundColor: "rgb(42, 136, 234)", color: "white", border: "none", width: "150px"}}>Pallet Qty</th>

        <td style={{background: "rgb(238, 236, 245)", color: "#4d4d4d", border: "none"}}>{line.tagLinePalletQty}</td>
      </tr>

    </tbody>
  </table>
    );
  }


  receiptFooter()
  {
    return (    
    <table  data-type="text" border="0" cellPadding="1"
      cellSpacing="1" width="100%" style={{tableLayout: "fixed", color: "white"}}
      >
      <tbody>
        <tr>
          <td style={{padding: "18px 0px 18px 0px", lineHeight: "15px", textAlign: "inherit"}}
            height="100%" valign="top" bgcolor="" >
            <div>
              <div style={{fontFamily: "inherit", textAlign: "center"}}><span
                style={{fontSize: "14px"}}><em><strong>For any questions or discrepancies
                  please contact your local Field representative.</strong></em></span>
              </div>
              <div style={{fontFamily: "inherit", textAlign: "center"}}><span
                style={{fontSize: "14px"}}><em><strong>Please do not reply, email sent from an
                  unmonitored address.</strong></em></span></div>
              <div></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    );
  }


  render() 
  {

    var receipt = this.state.receipt;

    var errors;
    if (Object.keys(this.state.errorBag).length > 0) 
    {
      var entries = Object.entries(this.state.errorBag);
      var errorBody = entries.map(e => {
        return <div>{e[1]}</div>
      });
      errors = <div id="errorbox">
        {errorBody}
      </div>
    } else {
      errors = <span/>
    }



    var busySpan = (this.state.isBusy) ? <span id="busyIcon"><FontAwesomeIcon icon={faSyncAlt} color="green" spin /><span style={{ color: "white", fontSize: "12pt", top: "75%" }}> &ensp; {this.state.busyMessage}</span></span>
      : <span />;


    return (


      (this.state.receipt) ?

      <div style={{marginLeft: "5vw", marginRight: "5vw", marginTop: "1vw"}}>

        {busySpan}
 
        {this.receiptHeader()}

        {this.receiptTop(receipt)}

        {this.receiptLines(receipt)}

        {this.receiptFooter()}

        {errors}


      </div >

      : <div>
          {busySpan}
          <div id="authcontainer">
            {errors}
          </div>
      </div>
    )
  }
}
